import axios from "axios";
import moment from "moment";
import { apiUrl, headers } from "../constant";
import { getToken, getBrowserTimezone } from '../utils/common'

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Was an unconditional hard-redirect on every 401, even when
      // already on /login -- any background call 401ing while logged
      // out (e.g. App.js's own unconditional getPublicHolidaysApi() on
      // every mount) reloaded the login page via window.location.href,
      // which re-ran the same call, 401'd again, reloaded again: an
      // infinite loop that blocked login entirely for anyone without a
      // currently-valid token. Also cleared a "token" key that was
      // never the real one (see utils/localStorage.js's "currentUser"),
      // so a 401 never actually cleared stale auth state either.
      if (window.location.pathname !== "/login") {
        localStorage.clear();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

class employeeApi {
  addEmployeeApi = async (newEmployee) => {
    return axios({
      method: "post",
      url: apiUrl + `/api/v1/employees`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        name: newEmployee.name,
        gender: newEmployee.gender,
        dateOfBirth: newEmployee.dateOfBirth,
        education: newEmployee.education ? newEmployee.education : "N/A",
        email: newEmployee.email,
        joiningDate: newEmployee.joiningDate,
        designation: "",
        designationId: newEmployee.designationId,
        address: newEmployee.address,
        phoneNumber: newEmployee.phoneNumber,
        salary: newEmployee.salary ? newEmployee.salary : "0000",
        permanentDate:
          newEmployee.permanentDate == "Same"
            ? newEmployee.joiningDate
            : newEmployee.permanentDate,
        leavingDate: newEmployee.leavingDate || null,
        status: newEmployee.status,
        appointmentLetterStatus: newEmployee.appointmentLetterStatus === "true",
        agreementSignStatus: newEmployee.agreementSignStatus === "true",
        linkedInProfile: newEmployee.linkedInProfile
          ? newEmployee.linkedInProfile
          : "N/A",
        personalEmail: newEmployee.personalEmail,
        cnic: newEmployee.cnic,
        employee_No: newEmployee.employee_No,
        workExperience: newEmployee.workExperience
          ? newEmployee.workExperience
          : "0",
        technology: newEmployee.technology ? newEmployee.technology : "N/A",
        profile_url: newEmployee.profile_url ? newEmployee.profile_url : "",
        personal_leaves: newEmployee.personal_leaves ? newEmployee.personal_leaves : 0,
        compassionate_leave: newEmployee.compassionate_leave ? newEmployee.compassionate_leave.toString() === "true" : false,
        service_leave: newEmployee.service_leave ? newEmployee.service_leave.toString() === "true" : false,
        paternity_leaves: newEmployee.paternity_leaves ? newEmployee.paternity_leaves.toString() === "true" : false,
        bereavement_leave: newEmployee.bereavement_leave ? newEmployee.bereavement_leave.toString() === "true" : false,
        compensation_leave: newEmployee.compensation_leave ? newEmployee.compensation_leave.toString() === "true" : false,
        exemptedFromAttendance: newEmployee.exemptedFromAttendance ? newEmployee.exemptedFromAttendance.toString() === "true" : false,
        exemptedFromEvaluation: newEmployee.exemptedFromEvaluation ? newEmployee.exemptedFromEvaluation.toString() === "true" : false
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        const error = JSON.stringify(err);
        console.log("Employee Error", error);
        return {
          error: true,
          data: err,
        };
      });
  };

  addBulkEmployeeApi = async (newEmployee) => {
    return axios({
      method: "post",
      url: apiUrl + `/api/v1/employees/bulkCreate`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        name: newEmployee.name,
        gender: newEmployee.gender,
        dateOfBirth: newEmployee.dateOfBirth,
        education: newEmployee.education ? newEmployee.education : "N/A",
        email: newEmployee.email,
        joiningDate: newEmployee.joiningDate,
        designation: newEmployee.designation,
        address: newEmployee.address,
        phoneNumber: newEmployee.phoneNumber,
        salary: newEmployee.salary ? newEmployee.salary : "0000",
        permanentDate:
          newEmployee.permanentDate == "Same"
            ? newEmployee.joiningDate
            : newEmployee.permanentDate,
        status: newEmployee.status,
        appointmentLetterStatus: newEmployee.appointmentLetterStatus === "true",
        agreementSignStatus: newEmployee.agreementSignStatus === "true",
        linkedInProfile: newEmployee.linkedInProfile
          ? newEmployee.linkedInProfile
          : "N/A",
        personalEmail: newEmployee.personalEmail,
        cnic: newEmployee.cnic,
        employee_No: newEmployee.employee_No,
        workExperience: newEmployee.workExperience
          ? newEmployee.workExperience
          : "0",
        technology: newEmployee.technology ? newEmployee.technology : "N/A",
        profile_url: newEmployee.profile_url ? newEmployee.profile_url : "",
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        const error = JSON.stringify(err);
        console.log("Employee Error", error);
        return {
          error: true,
          data: err,
        };
      });
  };

  deleteLeaves(id,title) {
    return axios({
      method: "delete",
      url: apiUrl + `/api/v1/employeeLeaves/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {title},
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  }

  updateEmployeeLeavesApi = async (leaves,title) => {
    return axios({
      method: "post",
      url: apiUrl + `/api/v1/employeeLeaves`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        id: leaves.id,
        EmployeeId: leaves.EmployeeId,
        ApplicationDate: moment(),
        LeavesDates: leaves.LeavesDates.sort(),
        category: leaves.category,
        LeaveType: leaves.LeaveType,
        ApplicationStatus: leaves.ApplicationStatus,
        Reason: leaves.Reason,
        rejection_reason: leaves.rejection_reason,
        title
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        console.log("Employee Error", err);
        return {
          error: true,
          data: err.response?.data?.message || "An error occurred while updating the employee leave.",
        };
      });
  };

  updateEmployeeLeaveByIdApi = async (leave, title) => {
   if (!leave?.id) {
      // toast isn't imported in this API-layer file -- the caller already
      // toasts res.data on { error: true }, so just return the error object.
      return {
        error: true,
        data: "Leave ID is required for update",
      };
   }

  return axios({
    method: "patch",
    url: `${apiUrl}/api/v1/employeeLeaves/${leave.id}`,
    headers: {
      ...headers,
      Authorization: `Bearer ${getToken()?.access_token}`,
    },
    data: {
      EmployeeId: leave.EmployeeId,
      ApplicationDate: new Date().toISOString(),
      LeavesDates: leave.LeavesDates.sort(),
      category: leave.category,
      LeaveType: leave.LeaveType,
      ApplicationStatus: leave.ApplicationStatus,
      Reason: leave.Reason,
      rejection_reason: leave.rejection_reason,
      title,
      compensation_leave_id: leave.compensation_leave_id,
    },
  })
    .then((result) => ({
      error: false,
      data: result.data,
    }))
    .catch((err) => {
      console.error("Update Employee Leave Error", err);
      return {
        error: true,
        data: err.response?.data?.message || "An error occurred while updating the employee leave.",
      };
    });
};


  addEmployeeLeavesApi = async (leaves,title) => {
    return axios({
      method: "post",
      url: apiUrl + `/api/v1/employeeLeaves`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        EmployeeId: leaves.EmployeeId,
        ApplicationDate: moment(),
        LeavesDates: leaves.LeavesDates.sort(),
        category: leaves.category,
        LeaveType: leaves.LeaveType,
        ApplicationStatus: leaves.ApplicationStatus,
        Reason: leaves.Reason,
        rejection_reason: leaves.rejection_reason,
        title,
        compensation_leave_id: leaves.compensation_leave_id

      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        console.log("Employee Error", err);
        return {
          error: true,
          data: err.response?.data?.message || "An error occurred while applying for leave.",
        };
      });
  };

  getEmployeesLeavesApi = async (id) => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employeeLeaves/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getLeaveByIdApi = async (id) => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employeeLeaves/leave/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getAllEmployeesLeavesApi = async () => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employeeLeaves`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  // Dashboard "Upcoming Leave" widget -- Approved + still-Applied leaves
  // company-wide, soonest-first, pre-filtered/sorted server-side (see
  // dbhrm-be's EmployeeLeavesService.findUpcomingLeaves).
  getUpcomingLeavesApi = async (limit) => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employeeLeaves/upcoming`,
      params: { ...(limit ? { limit } : {}), tz: getBrowserTimezone() },
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getLeaveApplicationsApi = async () => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employeeLeaves/applications`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getPublicHolidaysApi = async () => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/public-holidays`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  addPublicHolidaysApi = async (data) => {

    return axios({
      method: "post",
      url: apiUrl + `/api/v1/public-holidays`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        title: data.title,
        year: data.year,
        publicHolidays: data.LeavesDates.sort()

      }
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  updatePublicHolidaysApi = async (id, data) => {

    return axios({
      method: "patch",
      url: apiUrl + `/api/v1/public-holidays/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        title: data.title,
        year: data.year,
        publicHolidays: data.LeavesDates.sort()
      }
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  deletePublicHolidaysApi = async (id) => {

    return axios({
      method: "delete",
      url: apiUrl + `/api/v1/public-holidays/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },

    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  deleteEmployeeApi = async (id) => {
    return axios({
      method: "delete",
      url: apiUrl + `/api/v1/employees/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getEmployeesApi = async (status = "Active", filter=[]) => {
    const filterParam = filter.length ? `&filter=${filter.join(",")}` : "";
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employees?status=${status}${filterParam}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`,
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };
  getActiveEmployeesApi = async () => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employees/active`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getEmployeesWithoutUserApi = async () => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employees/without_user`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`,
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getEmployeeApi = async (id,page,limit) => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employees/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getEmployeeByNoApi = async (no) => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employees/by-no/${no}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  updateEmployeeApi = async (newEmployee) => {
    return axios({
      method: "patch",
      url: apiUrl + `/api/v1/employees/${newEmployee.id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        name: newEmployee.name,
        gender: newEmployee.gender,
        dateOfBirth: newEmployee.dateOfBirth,
        education: newEmployee.education,
        email: newEmployee.email,
        joiningDate: newEmployee.joiningDate,
        leavingDate: newEmployee.leavingDate || null,
        designation:"",
        designationId: newEmployee.designationId,
        address: newEmployee.address,
        phoneNumber: newEmployee.phoneNumber,
        salary: newEmployee.salary,
        permanentDate: newEmployee.permanentDate,
        status: newEmployee.status,
        appointmentLetterStatus: newEmployee.appointmentLetterStatus === "true",
        agreementSignStatus: newEmployee.agreementSignStatus === "true",
        linkedInProfile: newEmployee.linkedInProfile,
        personalEmail: newEmployee.personalEmail,
        cnic: newEmployee.cnic,
        employee_No: newEmployee.employee_No,
        profile_url: newEmployee.profile_url,
        personal_leaves: newEmployee.personal_leaves ? newEmployee.personal_leaves : 0,
        compassionate_leave: newEmployee.compassionate_leave ? newEmployee.compassionate_leave.toString() === "true" : false,
        service_leave: newEmployee.service_leave ? newEmployee.service_leave.toString() === "true" : false,
        paternity_leaves: newEmployee.paternity_leaves ? newEmployee.paternity_leaves.toString() === "true" : false,
        bereavement_leave: newEmployee.bereavement_leave ? newEmployee.bereavement_leave.toString() === "true" : false,
        exemptedFromAttendance: newEmployee.exemptedFromAttendance ? newEmployee.exemptedFromAttendance.toString() === "true" : false,
        exemptedFromEvaluation: newEmployee.exemptedFromEvaluation ? newEmployee.exemptedFromEvaluation.toString() === "true" : false
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  // A dedicated, genuinely-partial PATCH -- updateEmployeeApi above
  // always sends every field it knows about, defaulting several
  // booleans (appointmentLetterStatus, exemptedFromEvaluation, etc.) to
  // false when the caller didn't pass them, which would silently clear
  // those flags if reused here for a picture-only update. The backend's
  // UpdateEmployeeDto is a PartialType, so a body with just profile_url
  // is safe and leaves every other field untouched.
  updateEmployeePictureApi = async (id, profile_url) => {
    return axios({
      method: "patch",
      url: apiUrl + `/api/v1/employees/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: { profile_url },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getEmployeeWorkHistory = async (empId) => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employees/work_history/${empId}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  addLeavesTypesApi = async (newType, id) => {
    newType.employeeid = id;
    return axios({
      method: "post",
      url: apiUrl + `/api/v1/leaves-types`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },

      data: {
        // newType's default shape always carries compensation_leave/
        // compensationLeavesDetails, which aren't real create-time fields
        // on LeavesTypes -- deliberately not sending them (see plan notes
        // on LeavesTypesController's missing permission guard).
        personal_leaves: newType.personal_leaves,
        year: newType.year,
        compassionate_leave: newType.compassionate_leave,
        service_leave: newType.service_leave,
        paternity_leaves: newType.paternity_leaves,
        bereavement_leave: newType.bereavement_leave,
        employeeid: newType.employeeid,
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        const error = JSON.stringify(err);
        console.log("Leave Error", error);
        return {
          error: true,
          data: err,
        };
      });
  };
  updateLeavesTypesApi = async (newType) => {
    return axios({
      method: "patch",
      url: apiUrl + `/api/v1/leaves-types/${newType.id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        personal_leaves: newType.personal_leaves,
        compassionate_leave: newType.compassionate_leave,
        service_leave: newType.service_leave,
        paternity_leaves: newType.paternity_leaves,
        bereavement_leave: newType.bereavement_leave,
        compensation_leave: newType.compensation_leave,
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        const error = JSON.stringify(err);
        console.log("Leave Error", error);
        return {
          error: true,
          data: err,
        };
      });
  };
  deleteLeavesTypesApi = async (id) => {
    return axios({
      method: "delete",
      url: apiUrl + `/api/v1/leaves-types/${id}`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getEmployeeLeavesTypesApi = async (id,year) => {
    let formattedUrl = `/api/v1/leaves-types/employee/${id}`;
    if (year) {
      formattedUrl += `?year=${year}`;
    }
    return axios({
      method: "get",
      url: apiUrl + formattedUrl,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getEmployeeLeavesByIdApi = async (id, year) => {
    let formattedUrl = `/api/v1/employeeLeaves/employee/${id}`;
    
    if (year) {
      formattedUrl += `/${year}`;
    }

    try {
      const result = await axios({
        method: "get",
        url: apiUrl + formattedUrl,
        headers: {
          ...headers,
          Authorization: `Bearer ${getToken()?.access_token}`
        },
      });

      return {
        error: false,
        data: result.data,
      };
    } catch (err) {
      return {
        error: true,
        data: err,
      };
    }
  };

  getLeavesTypesApi = async () => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/leaves-types`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getAllEmployeesOnLeave = async (includeAllApprovedLeaves) => {
    return axios({
      method: "get",
      url: apiUrl + `/api/v1/employeeLeaves/approved`,
      params : { ...(includeAllApprovedLeaves ? {include_all_approved_leaves: true}: {}), tz: getBrowserTimezone() },
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

    getTodaysAbsents = async (date) => {
      return axios({
        method: "get",
        url: apiUrl + `/api/v1/employeeAttendance/getTodaysAbsents/${date}`,
        headers: {
          ...headers,
          Authorization: `Bearer ${getToken()?.access_token}`,
      },
      params: { tz: getBrowserTimezone() },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };

  getEmployeeEmailValidationApi = async (email) => {
    return axios({
      method: "post",
      url: apiUrl + `/api/v1/employees/email-validation`,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()?.access_token}`
      },
      data: {
        email
      },
    })
      .then((result) => {
        return {
          error: false,
          data: result.data,
        };
      })
      .catch((err) => {
        return {
          error: true,
          data: err,
        };
      });
  };


}
export let employeeRequests = new employeeApi();
